import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ApexColumnChart from '../../../components/charts/ApexColumnChart';
import { Icons } from '../../../components/base/BootstrapComponents';
import { getClientData } from '../../Client/reducer';
import { PARKING_METER_STATUS } from '../../ParkingMeter/constants';

export default function ParkingMeterStatCard({ data }) {
  const {
    count: {
      ERROR = 0,
      WARNING = 0,
      OK = 0,
    } = {
      ERROR: 0,
      WARNING: 0,
      OK: 0,
    },
    percent: {
      ERROR: errorPercent = 0,
      WARNING: warningPercent = 0,
      OK: okPercent = 0,
    } = {
      ERROR: 0,
      WARNING: 0,
      OK: 0,
    },
    total = 0,
  } = data;
  const { clientData } = useSelector(getClientData);
  const { permission_keys } = clientData;
  const navigate = useNavigate();
  const series = OK + WARNING + ERROR > 0 ? [[OK, WARNING, ERROR]] : [[]];
  const columnDistributedChartData = {
    series,
    labels: ['Исправен', 'Некритическая \n поломка', 'Неисправен'],
    loading: false,
  };

  const handleColumnClick = (a, b, c) => {
    const config = [
      PARKING_METER_STATUS.OK,
      PARKING_METER_STATUS.WARNING,
      PARKING_METER_STATUS.ERROR,
    ];
    if (permission_keys && permission_keys.length) {
      const a = ['frontend_menu_parkomat'].every(routePermission => !!permission_keys.find(item => item === routePermission));
      if (a && c && c.dataPointIndex >= 0) {
        navigate(`/parking-meters?status=${config[c.dataPointIndex]}&clearOther=1`);
      }
    }
  };

  return (
    <div className="frame">
      <div className="dashboard-stat-card">
        <div className="dashboard-stat-chart">
          <ApexColumnChart
            {...columnDistributedChartData}
            title="Паркоматы"
            className=""
            distributed
            height={170}
            hideLegend
            onClick={handleColumnClick}
          />
        </div>
        <div className="dashboard-stat-text">
          <div className="parking-meter-state">
            <div className="parking-meter-state-wrapper">
              <Icons customIcon icon="parking-meter" className="parking-meter-state-icons" />
            </div>
            <div className="parking-meter-text">
              <div className="parking-meter-text-1 f5">
                <span className="pmw-number"><span className="pmw-count">{WARNING + ERROR}</span> из {total}</span><br />
                паркоматов<br />
                требуют внимания
              </div>
              <div className="parking-meter-state-percent">{Number(errorPercent + warningPercent).toFixed(0)}%</div>
            </div>
          </div>
          <div className="parking-meter-state-text">неисправных паркоматов</div>
        </div>
      </div>
    </div>
  );
}
